export const LoginDetailsInitialState = {
  token: '',
  firstName: '',
  lastName: '',
};
